interface TableField {
  key: string;
  label: string;
  selected: boolean;
  subKey?: string;
  isImage?: boolean; // ✅ ADD THIS
}


import { Component, OnInit } from '@angular/core';
import { RawMetalEntryComponent } from '../raw-metal-entry/raw-metal-entry.component';
import { NgFor, NgIf } from '@angular/common';
import { RawMetalService } from '../../../../Services/Raw_Metal/raw-metal.service';
import { ApiService } from '../../../../Services/api.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FormsModule } from '@angular/forms';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import { RouterLink } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-raw-metal-list',
  imports: [NgFor, FormsModule, NgIf, RouterLink],
  templateUrl: './raw-metal-list.component.html',
  styleUrl: './raw-metal-list.component.css',
})
export class RawMetalListComponent implements OnInit {

  paginatedStockList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;
  // rawMetallist: any;
  rawmetaldata: any;
  rawmetalId: any;
  rawMetalProductId: any;
  rawMetalEntryForm: any;

  showDropdown: boolean = false;
  ultFields: any[] = [];

  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  rawMetallist: any[] = [];
  item: any;
  globalSearchText: any;
  defaultFields: any[] = [];
  visibleRowCount: any;
  // Filtered + Paginated
  //for image  mapping
  rawMetalImageMap = new Map<number, string>();
  startDate: string = '';
endDate: string = '';
filteredRawMetalList: any[] = [];



  constructor(
    private rawmetalservice: RawMetalService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {

    const savedSelections = localStorage.getItem('columnSelections');
    if (savedSelections) {
      this.selectedFields = JSON.parse(savedSelections);
    }
    this.getRawMetalList();
    this.filterTable();

  }
  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedStockList = this.rawMetallist.slice(start, end);
  }

  getRawMetalList() {
    this.rawmetalservice.getRawMetalEntries().subscribe((response: any) => {
      if (response?.data?.length) {
        console.log('Raw metal data:', response.data);
        this.rawMetallist = response.data
          .filter((item: any) => item.st_product_code_type === 'raw_metal')
          .sort((a: any, b: any) => b.id - a.id);

        this.totalPages = Math.ceil(this.rawMetallist.length / this.itemsPerPage);
        this.currentPage = 1;
        this.updatePaginatedList();
      } else {
        this.rawMetallist = [];
        this.paginatedStockList = [];
        this.totalPages = 0;
      }
    });
  }


  deleteMetal(id: any) {
    this.rawmetalservice.deleteRawMetalEntry(id).subscribe(
      (response: any) => {
        this.notificationService.showSuccess('Raw metal deleted successfully!', 'Success');
        this.getRawMetalList();
      },
      (error: any) => {
        this.notificationService.showError('Failed to delete raw metal. Please try again.', 'Error');
      }
    );


  }

  updateVisibleRows() {
    this.paginatedStockList = this.rawMetallist.slice(
      0,
      this.visibleRowCount
    );
  }


  selectedFields: TableField[] = [
    { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },
    { key: 'st_item_code', label: 'Code', selected: true }
    , { key: 'st_metal_type', label: 'Metal Type', selected: true },
    { key: 'st_item_name', label: 'Name', selected: true },
    { key: 'st_item_size', label: 'Size', selected: true },
    { key: 'st_subunit', label: 'Per peice weight', selected: true },
    // { key: 'st_avg_subunit', label: 'Avg Per peice weight', selected: true },
    { key: 'st_total_wt', label: 'Total Weight', selected: true },
    { key: 'st_quantity', label: 'Quantity', selected: true },
    { key: 'st_metal_rate', label: 'Silver Rate', selected: true },
    // { key: 'st_avg_metal_rate', label: 'Avg Metal Rate', selected: true },
    { key: 'st_unit_price', label: 'Per piece silver price', selected: true },
    // { key: 'st_avg_unit_price', label: 'Avg Per piece silver price', selected: true },
    { key: 'st_per_gm_labour', label: 'Per Gram Labour', selected: true },
    { key: 'st_cny_labour', label: 'CNY Labour', selected: true },
    // { key: 'st_avg_per_gm_labour', label: 'Avg Per Gram Labour', selected: true },
    { key: 'st_per_piece_labour', label: 'Per piece Labour', selected: true },
    // { key: 'st_avg_per_piece_labour', label: 'Avg Per piece Labour', selected: true },
    { key: 'st_per_gm_shipping', label: 'Per Gram Shipping', selected: true },
    // { key: 'st_avg_per_gm_shipping', label: 'Avg Per Gram Shipping', selected: true },
    { key: 'st_per_piece_shipping', label: 'Per Peice Shipping price', selected: true },
    // { key: 'st_avg_per_piece_shipping', label: ' Avg Per Peice Shipping price', selected: true },
    { key: 'st_sub_unit_price', label: 'Per Piece total price', selected: true },
    // { key: 'st_avg_sub_unit_price', label: 'Avg Per Piece total price', selected: true },

  ];



  filterTable() {

  let filtered = this.rawMetallist.filter(item => {

    /* ================= DATE FILTER ================= */

    if (this.startDate || this.endDate) {

      const createdAt = item['created_at'];
      if (!createdAt) return false;

      const itemDate = new Date(createdAt).setHours(0, 0, 0, 0);
      const start = this.startDate
        ? new Date(this.startDate).setHours(0, 0, 0, 0)
        : null;
      const end = this.endDate
        ? new Date(this.endDate).setHours(0, 0, 0, 0)
        : null;

      if (start && itemDate < start) return false;
      if (end && itemDate > end) return false;
    }

    /* ================= COLUMN FILTER ================= */

    const matchesFieldFilters = this.selectedFields.every(field => {

      const searchTerm = (this.searchValues[field.key] || '')
        .trim()
        .toLowerCase();

      if (!searchTerm) return true;

      const fieldValue = (item[field.key] ?? '')
        .toString()
        .toLowerCase();

      return fieldValue.includes(searchTerm);
    });

    /* ================= GLOBAL SEARCH ================= */

    const matchesGlobalSearch = this.globalSearchText
      ? Object.values(item).some(val =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
      : true;

    return matchesFieldFilters && matchesGlobalSearch;
  });

  /* ================= SORT ================= */

  if (this.sortKey) {
    filtered.sort((a, b) => {
      const valA = a[this.sortKey] ?? '';
      const valB = b[this.sortKey] ?? '';

      return this.sortDirection === 'asc'
        ? valA > valB ? 1 : valA < valB ? -1 : 0
        : valA < valB ? 1 : valA > valB ? -1 : 0;
    });
  }

  /* ================= SAVE FILTERED ================= */

  this.filteredRawMetalList = filtered;

  /* ================= PAGINATION ================= */

  this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);
  this.currentPage = Math.min(this.currentPage, this.totalPages || 1);

  const start = (this.currentPage - 1) * this.itemsPerPage;

  this.paginatedStockList = filtered.slice(
    start,
    start + this.itemsPerPage
  );
}




  applyColumnSelection() {
    localStorage.setItem('columnSelections', JSON.stringify(this.selectedFields));
    this.showDropdown = false;
  }


  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.filterTable();
  }

  formatNumber(value: any): string {
    const num = parseFloat(value);
    return isNaN(num) ? '-' : num.toFixed(2);
  }

  formatFieldValue(item: any, field: any): string {
    const value = field.subKey ? item[field.key]?.[field.subKey] : item[field.key];

    if (value == null || value === '') return '-';

    const isNumeric = !isNaN(value) && typeof value !== 'object';
    return isNumeric ? this.formatNumber(value) : value;
  }

  selectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = true));
  }

  deselectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = false));
  }


  get selectedFieldss() {
    return this.selectedFields.filter((field) => field.selected);
  }

  formatPdfValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';

    // number formatting
    if (!isNaN(value) && typeof value !== 'object') {
      return Number(value).toFixed(2);
    }

    // object safety
    if (typeof value === 'object') {
      return Object.values(value)
        .filter(v => typeof v !== 'object')
        .join(', ');
    }

    return String(value);
  }
  /* ============================================================
   IMAGE PROXY HELPERS
============================================================ */

proxyImageUrl(url: string): string {

  if (!url) return url;

  if (url.includes('/api/image-proxy/')) return url;

  const match = url.match(/\/storage\/(.+)$/);

  if (!match) return url;

  //  dynamic backend (dev/prod safe)
  const backendBase =
    environment.apiBaseUrl.replace(/\/api\/$/, '');

  return `${backendBase}/api/image-proxy/${match[1]}`;
}


/* ============================================================
   LOAD IMAGE AS BASE64
============================================================ */

async loadImageBase64(url: string): Promise<string | null> {
  try {

    const proxiedUrl = this.proxyImageUrl(url);

    console.log(' Loading image:', proxiedUrl);

    const res = await fetch(proxiedUrl);

    if (!res.ok) {
      console.error('HTTP error:', res.status);
      throw new Error(res.statusText);
    }

    const blob = await res.blob();

    return await new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });

  } catch (err) {
    console.error(' Image load FAILED:', url, err);
    return null;
  }
}


/* ============================================================
   PRELOAD RAW METAL IMAGES
============================================================ */



async prepareRawMetalImages(): Promise<void> {

  console.log(' Preloading Raw Metal images...');

  this.rawMetalImageMap.clear();

   const dataToProcess = this.getExportSourceData();
    for (const row of dataToProcess as any[]) {

    const imgUrl = row.st_image1;

    console.log('➡ Row image:', imgUrl);

    if (!imgUrl) continue;

    const base64 = await this.loadImageBase64(imgUrl);

    if (base64) {
      this.rawMetalImageMap.set(row.st_id, base64);
      console.log(' Image OK');
    } else {
      console.log(' Image NULL');
    }
  }

  console.log(' Raw Metal preload finished');
}


////////////////////////////////////////////////////////////////
//  MAIN RAW METAL PDF
////////////////////////////////////////////////////////////////

async downloadPDF(): Promise<void> {

  //  preload FIRST
  await this.prepareRawMetalImages();

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a3',
  });

  const selectedFields =
    this.selectedFields.filter(f => f.selected);

  if (!selectedFields.length) {
    this.notificationService.showError(
      'Please select at least one column',
      'Error'
    );
    return;
  }

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();


  /* ================= HEADER ================= */

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.text('Raw Metal Report', pageWidth / 2, 16, {
    align: 'center'
  });

  doc.setFontSize(9);
  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    pageWidth - 15,
    10,
    { align: 'right' }
  );


  /* ================= TABLE ================= */

  const headers = [
    { header: 'No.', dataKey: 'no' },
    ...selectedFields.map(f => ({
      header: f.label,
      dataKey: f.key,
    })),
  ];

 const sourceData = this.getExportSourceData();

const body = sourceData.map((item, index) => {


      const row: any = { no: index + 1 };

      selectedFields.forEach(f => {

        // 🖼 IMAGE COLUMN
        if (f.key === 'st_image1') {

          row[f.key] = '';

          row.__img =
            this.rawMetalImageMap.get(item.st_id);

        } else {

          const rawValue = f.subKey
            ? item[f.key]?.[f.subKey]
            : item[f.key];

          row[f.key] =
            this.formatPdfValue(rawValue);
        }
      });

      return row;
    }
  );


  autoTable(doc, {

    columns: headers,
    body,

    startY: 24,
    margin: { left: 6, right: 6 },

    theme: 'grid',
    tableWidth: pageWidth - 12,

    rowPageBreak: 'auto',


    /* ---------- BASE STYLES ---------- */

    styles: {
      fontSize: 6.2,
      cellPadding: 1.3,
      overflow: 'linebreak',
      valign: 'middle',
    },

    headStyles: {
      fillColor: [193, 151, 37],
      textColor: 255,
      halign: 'center',
      fontSize: 7,
      fontStyle: 'bold',
    },

    columnStyles: {
      no: { cellWidth: 12, halign: 'center' },
      st_image1: { cellWidth: 18 },
    },

    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },


    /* ---------- FIX IMAGE CELL HEIGHT ---------- */

    didParseCell: data => {

      if (
        data.section === 'body' &&
        data.column.dataKey === 'st_image1'
      ) {
        data.cell.styles.minCellHeight = 18;
        data.cell.styles.halign = 'center';
        data.cell.styles.valign = 'middle';
      }
    },


    /* ---------- DRAW IMAGE ---------- */

   didDrawCell: data => {

  if (data.column.dataKey !== 'st_image1') return;

  const rowAny = data.row.raw as any;

  const img = rowAny?.__img;

  if (!img) return;

  //  AUTO FIT BUT LIMIT MAX SIZE
  const padding = 3;

  const maxW = data.cell.width - padding * 2;
  const maxH = data.cell.height - padding * 2;

  //  HARD LIMIT (makes it small)
  const MAX_IMG_SIZE = 18;

  const size = Math.min(maxW, maxH, MAX_IMG_SIZE);

  const x =
    data.cell.x +
    (data.cell.width - size) / 2;

  const y =
    data.cell.y +
    (data.cell.height - size) / 2;

  doc.addImage(
    img,
    'JPEG',
    x,
    y,
    size,
    size,
    undefined,
    'FAST'
  );
},


    /* ---------- FOOTER ---------- */

    didDrawPage: () => {

      doc.setFontSize(8);

      doc.text(
        `Page ${(doc as any).getNumberOfPages()}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
    },

  });

  doc.save('raw-metal-report.pdf');
}

downloadExcel(): void {

  const selectedFields = this.selectedFields.filter(
    (field) => field.selected
  );

  if (!selectedFields.length) {
    return;
  }

  // numeric backend keys
  const numericKeys = [
    'st_subunit',
    'st_avg_subunit',
    'st_total_wt',
    'st_quantity',
    'st_metal_rate',
    'st_avg_metal_rate',
    'st_unit_price',
    'st_avg_unit_price',
    'st_per_gm_labour',
    'st_avg_per_gm_labour',
    'st_per_piece_labour',
    'st_avg_per_piece_labour',
    'st_per_gm_shipping',
    'st_avg_per_gm_shipping',
    'st_per_piece_shipping',
    'st_avg_per_piece_shipping',
    'st_sub_unit_price',
    'st_avg_sub_unit_price'
  ];

  /* =============================
     CREATE HEADER MANUALLY
  ============================== */

  const headers = ['No.', ...selectedFields.map(f => f.label)];

  /* =============================
     CREATE ROWS
  ============================== */

  const sourceData = this.getExportSourceData();

const rows = sourceData.map((item, index) => {


    const row: any = { 'No.': index + 1 };

    selectedFields.forEach((field) => {

      let value: any = '';

      // skip image column
      if (!field.isImage) {
        value = item[field.key];
      }

      // force numeric
      if (numericKeys.includes(field.key)) {
        value =
          value !== null &&
          value !== undefined &&
          value !== ''
            ? Number(value)
            : 0;
      }

      row[field.label] = value ?? '';
    });

    return row;
  });

  /* =============================
     HANDLE EMPTY DATA CASE
  ============================== */

  let worksheet: XLSX.WorkSheet;

  if (rows.length === 0) {

    // 🔥 IMPORTANT — show headers even if no data
    worksheet = XLSX.utils.aoa_to_sheet([headers]);

  } else {

    worksheet = XLSX.utils.json_to_sheet(rows);

    // force numeric cell types
    Object.keys(worksheet).forEach((cell) => {
      if (cell.startsWith('!')) return;

      const c = worksheet[cell];
      if (typeof c.v === 'number') {
        c.t = 'n';
      }
    });
  }

  /* =============================
     CREATE WORKBOOK
  ============================== */

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Product List': worksheet },
    SheetNames: ['Product List']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  FileSaver.saveAs(
    new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    'Raw-metal-product-list.xlsx'
  );
}




  downloadJSONAll(): void {
    const data = this.getExportSourceData();


    const jsonString = JSON.stringify(data, null, 2); // Pretty print with indentation

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = 'Raw-metal-product-list.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href); // Clean up
  }

  downloadCSV(): void {
    const data = this.getExportSourceData();


    if (!data.length) return;

    // Extract headers dynamically from the first object
    const selectedFields = this.selectedFields?.filter(f => f.selected) || [];
    const headers = ['No.', ...selectedFields.map(f => f.label)];
    const keys = selectedFields.map(f => f.key);

    // Build CSV content
    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...keys.map(key => {
          const value = item[key];
          return typeof value === 'string' && value.includes(',')
            ? `"${value}"` // Wrap comma-containing values in quotes
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    // Trigger file download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = 'Raw-metal-product-list.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href); // Clean up
  }


  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }


  restoreColumnSelection() {
    localStorage.removeItem('columnSelections');
    this.selectedFields = [
      { key: 'st_image1', label: 'Product Image', isImage: true, selected: true },
      { key: 'st_item_code', label: 'Code', selected: true }
      , { key: 'st_metal_type', label: 'Metal Type', selected: true },
      { key: 'st_item_name', label: 'Name', selected: true },
      { key: 'st_item_size', label: 'Size', selected: true },
      { key: 'st_subunit', label: 'Per peice weight', selected: true },
      // { key: 'st_avg_subunit', label: 'Avg Per peice weight', selected: true },
      { key: 'st_total_wt', label: 'Total Weight', selected: true },
      { key: 'st_quantity', label: 'Quantity', selected: true },
      { key: 'st_metal_rate', label: 'Metal Rate', selected: true },
      // { key: 'st_avg_metal_rate', label: 'Avg Metal Rate', selected: true },
      { key: 'st_unit_price', label: 'Per piece silver price', selected: true },
      // { key: 'st_avg_unit_price', label: 'Avg Per piece silver price', selected: true },
      { key: 'st_per_gm_labour', label: 'CNY Labour', selected: true },
      { key: 'st_per_gm_labour', label: 'Per Gram Labour', selected: true },
      // { key: 'st_avg_per_gm_labour', label: 'Avg Per Gram Labour', selected: true },
      { key: 'st_per_piece_labour', label: 'Per piece Labour', selected: true },
      // { key: 'st_avg_per_piece_labour', label: 'Avg Per piece Labour', selected: true },
      { key: 'st_per_gm_shipping', label: 'Per Gram Shipping', selected: true },
      // { key: 'st_avg_per_gm_shipping', label: 'Avg Per Gram Shipping', selected: true },
      { key: 'st_per_piece_shipping', label: 'Per Peice Shipping price', selected: true },
      // { key: 'st_avg_per_piece_shipping', label: ' Avg Per Peice Shipping price', selected: true },
      { key: 'st_sub_unit_price', label: 'Per Piece total price', selected: true },
      // { key: 'st_avg_sub_unit_price', label: 'Avg Per Piece total price', selected: true },
    ];
  }

 async printTable() {

  // 🔒 Ensure images are preloaded first
  await this.prepareRawMetalImages();

  let printContent = `
  <html>
  <head>
    <title>Raw Metal List</title>

   <style>

  body {
    font-family: Arial, sans-serif;
  }

  table {
    width: 100%;
    border-collapse: separate;   /* 🔥 instead of collapse */
    border-spacing: 0;
    font-size: 11px;
  }

  th, td {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
    padding: 6px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    border-left: 2px solid #000;
  }

  thead th {
    border-top: 2px solid #000;
    background-color: #f2f2f2;
    font-weight: 600;
  }

  tbody tr:last-child td {
    border-bottom: 2px solid #000;
  }

  img {
    max-width: 80px;
    max-height: 80px;
    object-fit: contain;
    display: block;
    margin: auto;
  }

  @media print {

    @page {
      size: auto;
      margin: 8mm;
    }

    body {
      margin: 0;
    }

    svg,
    button {
      display: none !important;
    }

  }

</style>

  </head>
  <body>

    <h3>Raw Metal List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

  // 🧾 HEADERS
  this.selectedFields.forEach(field => {
    if (field.selected) {
      printContent += `<th>${field.label}</th>`;
    }
  });

  printContent += `
        </tr>
      </thead>
      <tbody>
  `;

  // 📦 ROWS
  const data = this.getExportSourceData();
  data.forEach((item, index) => {

    printContent += `
      <tr>
        <td>${(this.currentPage - 1) * this.itemsPerPage + index + 1}</td>
    `;

    this.selectedFields.forEach(field => {

      if (!field.selected) return;

      const value = item[field.key];

      // 🖼 IMAGE COLUMN → BASE64 FROM MAP
      if (field.key === 'st_image1') {

        const base64Img = this.rawMetalImageMap.get(item.st_id);

        printContent += `
          <td style="text-align:center">
            ${
              base64Img
                ? `<img src="${base64Img}" />`
                : ''
            }
          </td>
        `;

      } else {

        printContent += `<td>${value ?? ''}</td>`;

      }

    });

    printContent += `
      </tr>
    `;
  });

  printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

  // 🖨 OPEN PRINT WINDOW
  const printWindow = window.open('', '_blank');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    // ⏳ Wait for render before print
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
      }, 200);
    };
  }
}

  onFieldToggle(field: any) {
    field.selected = !field.selected;
    this.saveSelectedFields();
    this.filterTable();
  }

  saveSelectedFields() {
    localStorage.setItem('selectedFields', JSON.stringify(this.selectedFields));
  }


  openPackagingDetails(id: number): void {
    this.rawmetalservice.getRawMetalEntryById(id).subscribe(
      (response: any) => {
        const packaging = response.data;

        // Dynamically generate rows based on selected fields
        const rows = this.selectedFields
          .filter(field => field.selected)
          .map(field => {
            let value = packaging[field.key];

            // Handle nested object field (like st_item_category)
            if (field.subKey && typeof value === 'object' && value !== null) {
              value = value[field.subKey];
            }

            return `<p><strong>${field.label}:</strong> ${value ?? '-'}</p>`;
          })
          .join('');

        Swal.fire({
          title: `<strong style="font-size: 20px; color: #c19725;">Packaging Details</strong>`,
          html: `
            <div style="text-align: left; font-size: 14px; max-height: 70vh; overflow-y: auto; font-family: 'Segoe UI', sans-serif;">
              <section style="margin-bottom: 1.5rem;">
                <h3 style="background: #fdf5e4; color: #c19725; padding: 6px 10px; border-left: 4px solid #c19725;">Item Info</h3>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 8px;">
                  ${rows}
                </div>
              </section>
            </div>
          `,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: '<span style="color: white;">Close</span>',
          width: '650px',
          scrollbarPadding: false,
          customClass: {
            popup: 'packaging-details-popup',
            confirmButton: 'packaging-confirm-button'
          }
        });
      },
      (error) => {
        console.error('Error fetching packaging details', error);
        Swal.fire('Error', 'Unable to fetch packaging details. Please try again.', 'error');
      }
    );
  }


  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedList();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedList();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedList();
    }
  }

  get pageNumbers(): number[] {
    return Array(this.totalPages)
      .fill(0)
      .map((_, i) => i + 1);
  }
  private getExportSourceData(): any[] {

  const hasFilter =
    this.startDate ||
    this.endDate ||
    this.globalSearchText ||
    Object.values(this.searchValues).some(v => v);

  return hasFilter
    ? this.filteredRawMetalList
    : this.rawMetallist;
}

}
